import { Project, SubContractor, SubProject, SubProjectResource } from '../../../models/interfaces';
import { Box, Paper, Stack, Switch, Table, TableBody, TableCell, TableFooter, TableHead, TableRow, Typography, Chip, Tooltip, IconButton, CircularProgress } from '@mui/material';
import { useEffect, useState } from 'react';
import { calculateProjectCost, calculateResourceCost } from '../project-utils';
import LayersIcon from '@mui/icons-material/Layers'
import dayjs from 'dayjs';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../store';
import { addAssignBusyResourceIds, removeAssignBusyResourceIds } from '../../../slices/assign';
import { retrieveProjectsById } from '../../../slices/projects';
import { removeServerSubContractor } from '../../../slices/subcontractor';
import { Engineering } from '@mui/icons-material';


const ODD_OPACITY = 0.2;
const tableStyles = {
    stickyFooter: {
        position: 'sticky',
        bottom: 0,
        backgroundColor: 'background.paper',
        borderTop: '2px solid #e0e0e0',
    } as React.CSSProperties,
    cellMaterial: {
        '&:hover': {
            backgroundColor: 'lightgray', // Change background color on hover
        },
    } as React.CSSProperties,
};

export const ProjectSummarySubContractorCostsTableRow = (props: { project: Project, sub_project: SubProject, sub_project_colors: Record<string, string>, subcontractorcost: SubContractor, remove: boolean }) => {
    const dispatch = useDispatch<AppDispatch>();
    const [is_busy, setIsBusy] = useState(false);

    const handleUnassignFromProject = (subcontractorcost: SubContractor) => {
        setIsBusy(true);
        const updated_subcontractorcost = {
            ...props.subcontractorcost,
        }
        dispatch(removeServerSubContractor({ subcontractor: updated_subcontractorcost })).then((result) => {
            if (result.type === 'subcontractor/remove_server_subcontractor/fulfilled') {
                console.log('subcontractor cost deleted');
                const project = props.project;
                if (project?.id) {
                    dispatch(retrieveProjectsById({ ids: [project?.id] }));
                }
            } else {
                console.log('subcontractor cost delete failed')
            }
            setIsBusy(false);
        })
    }

    const handleCellContextMenu = (e: React.MouseEvent<HTMLTableCellElement, MouseEvent>, text: string) => {
        e.stopPropagation();
        e.preventDefault();
        if (text) {
            navigator.clipboard.writeText(text);
        }
    }

    return (
        <TableRow key={`${props.subcontractorcost.id}`} hover>
            <TableCell onContextMenu={(e) => handleCellContextMenu(e, `${props.subcontractorcost.id}`)}>
                <Tooltip title={`Subcontractor cost ${props.subcontractorcost.id}`}>
                    <Engineering />
                </Tooltip>
            </TableCell>
            <TableCell onContextMenu={(e) => handleCellContextMenu(e, props.sub_project.name.toLowerCase())}>
                <Tooltip title={`This is sub project ${props.sub_project.id}`}>
                    <Chip
                        label={props.sub_project.name.toLowerCase()}
                        size='small'
                        variant='outlined'
                        sx={{ bgcolor: props.sub_project_colors[props.sub_project.id], fontWeight: 'bold' }}
                    />
                </Tooltip>
            </TableCell>
            <TableCell onContextMenu={(e) => handleCellContextMenu(e, dayjs(props.subcontractorcost.server_timestamp_created).format('DD/MM/YYYY'))}>
                {dayjs(props.subcontractorcost.server_timestamp_created).format('DD/MM/YYYY')}
            </TableCell>
            <TableCell onContextMenu={(e) => handleCellContextMenu(e, props.subcontractorcost.description || '')}>
                {props.subcontractorcost.description}
            </TableCell>
            <TableCell align='right' onContextMenu={(e) => handleCellContextMenu(e, props.subcontractorcost.quantity.toFixed(2))}>
                {props.subcontractorcost.quantity.toFixed(2)}
            </TableCell>
            <TableCell onContextMenu={(e) => handleCellContextMenu(e, props.subcontractorcost.unit || '')}>
                {props.subcontractorcost.unit}
            </TableCell>
            <TableCell align='right' onContextMenu={(e) => handleCellContextMenu(e, props.subcontractorcost.cost_per_unit.toFixed(2))}>
                {props.subcontractorcost.cost_per_unit.toFixed(2)}
            </TableCell>
            <TableCell align='right' onContextMenu={(e) => handleCellContextMenu(e, props.subcontractorcost.cost.toFixed(2))}>
                {props.subcontractorcost.cost.toFixed(2)}
            </TableCell>
            <TableCell align='right' onContextMenu={(e) => handleCellContextMenu(e, (props.subcontractorcost.cost * 1.15).toFixed(2))}>
                {(props.subcontractorcost.cost * 1.15).toFixed(2)}
            </TableCell>
            <TableCell sx={{ p: 0, m: 0, px: 0.5 }} align='right'>
                {props.remove === true && (
                    is_busy ?
                        <CircularProgress size={'1rem'} />
                        :
                        <IconButton
                            size={'small'}
                            color='error'
                            onClick={() => handleUnassignFromProject(props.subcontractorcost)}
                        >
                            <CloseIcon fontSize='inherit' />
                        </IconButton>
                )
                }
            </TableCell>
        </TableRow>
    );
}